import React, { useContext } from 'react';
import { Badge } from 'antd';

import DeviceTypeContext from '@totem/components/deviceTypes/DeviceTypeContext';
import { isNotNull } from '@totem/utilities/common';
const CountBadge = () => {
  const { data } = useContext(DeviceTypeContext);

  return (
    <Badge overflowCount={99999} count={isNotNull(data) ? data.length : 0} />
  );
};

export default CountBadge;
